export const words = {
  search: 'Search',
  allProjects: 'All projects',
  goTo: 'Go to',
  issues: 'Issues',
  plans: 'Plans',
  record: 'Record',
  comments: 'Comments',
  results: 'Results',
  placeholder: 'Search issues, plans, comments and records — or paste a key',
  empty: 'Type to search.',
} as const
